import type { importedListingRoute } from '#/modules/listing/routing/listing.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { ImportedListingPageContainerLoadable } from './ImportedListingPageContainerLoadable';

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof importedListingRoute>,
) {
  await ImportedListingPageContainerLoadable.load();
}

export default function ImportedListingHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <ImportedListingPageContainerLoadable />;
}
